import { CreateElement } from 'src/vue'
import { Component, Prop } from 'vue-property-decorator'

import { TrainingPlans } from '@src/routes/content/training-plans'
import { TrainingCardInfo } from '@src/components/card/training-card/training-card-info/training-card-info'
import { Input } from 'src/elements/input/input'
import { Form } from 'src/components/form/form'
import SessionManager from '@src/lib/session_manager'
import { OptionGroup } from '@src/elements/select/option-group'
import { Option } from '@src/elements/select/option'
import { Select } from '@src/elements/select/select'
import { InfiniteScrollList } from '@src/components/table-list/infinite-scroll-list'
import TrainingPlan from '@src/data/training-plan'
import { TrainingPlanService } from '@src/service/training-plan'
import Member from '@src/data/member'
import { ErrorScreen } from '@src/components/error-screen/error-screen'
import { Link } from '@src/elements/link/link'

@Component({
  computed: {
    selectedMember () {
      return this.$store.state.selectedMember
    }
  }
})
export class ActivateTrainingPlans extends TrainingPlans {

  @Prop({ required: false, default: false })
  disableCreate: boolean

  @Prop({ required: false, default: true })
  allowAllPlans: boolean

  private selectedTrainingPlanId: number | null

  private noOfClubTrainings: number = 0
  private noOfMemberTrainings: number = 0
  private selectedMember: Member | null

  constructor () {
    super()
  }

  async initialize () {
    if (!this.allowAllPlans) await this.filterByType('member')
  }

  // override watcher from parent component
  async filtersChanged () { return }

  setSelectedTrainingPlan (id: number | null, name?: string, totalDays?: number | null) {
    this.selectedTrainingPlanId = id
    this.$forceUpdate()
    this.$store.dispatch('updateActiveTrainingWorkouts', { newTrainingPlanId: id, newTrainingPlanName: name, newTrainingPlanTotalDays: totalDays })
  }

  goToTrainingPlanBuilder () {
    this.$store.dispatch('removeNewTrainingPlan')
    this.$router.push(`${SessionManager.Instance.getBaseRoute()}/trainingPlan`)
  }

  mapTrainingPlan (trainingPlan: TrainingPlan, h) {
    return <TrainingCardInfo training={trainingPlan} key={trainingPlan.id} type='select'
                             isSelected={this.selectedTrainingPlanId ? trainingPlan.id === this.selectedTrainingPlanId : false}
                             updateCallback={this.setSelectedTrainingPlan} />
  }

  renderTypeSelect (h: CreateElement) {
    let typeFilterLabel = this.$t(`PAGE.CONTENT.TRAINING_PLAN.TYPES.${{
      'all': 'ALL',
      'club': 'CLUB_TRAINING_PLANS',
      'member': 'MEMBER_TRAINING_PLANS'
    }[`${this.trainingPlansFilters.type}`]}`)
    return <Select filter={true} ref='typeFilter' value={typeFilterLabel}>
      <OptionGroup>
        <Option type='single-option' value={'all'} label={this.$t('PAGE.CONTENT.TRAINING_PLAN.TYPES.ALL')}
                selected={this.trainingPlansFilters.type === 'all'} select={this.filterByType}
                detail={(this.noOfClubTrainings + this.noOfMemberTrainings).toString()} />
        <Option type='single-option' value={'club'} label={this.$t('PAGE.CONTENT.TRAINING_PLAN.TYPES.CLUB_TRAINING_PLANS')}
                selected={this.trainingPlansFilters.type === 'club'} select={this.filterByType}
                detail={this.noOfClubTrainings.toString()} />
        <Option type='single-option' value={'member'} label={this.$t('PAGE.CONTENT.TRAINING_PLAN.TYPES.MEMBER_TRAINING_PLANS')}
                selected={this.trainingPlansFilters.type === 'member'} select={this.filterByType}
                detail={this.noOfMemberTrainings.toString()} />
      </OptionGroup>
    </Select>
  }

  render (h: CreateElement) {
    // let typeFilterLabel
    // if (this.trainingPlansFilters.type === undefined) {
    //   typeFilterLabel = this.$t('ALL')
    // } else {
    //   typeFilterLabel = this.$t(`PAGE.CONTENT.TRAINING_PLAN.${{
    //     'home': 'HOME_PLANS',
    //     'tracked': 'TRACKED'
    //   }[`${this.trainingPlansFilters.type}`]}`)
    // }

    return <div class='training-plan-wrapper'>
      <Form direction={'row'}>
        <Input search={true} ref='nameFilter' valueChanged={this.filterByName} placeholder={this.$t('PAGE.CONTENT.TRAINING_PLAN.SEARCH_PLACEHOLDER')}
               value={this.trainingPlansFilters.name} />
        {/*Hide home workouts*/}
        {/*<Select filter={true} ref='typeFilter' value={typeFilterLabel}>*/}
        {/*  <OptionGroup>*/}
        {/*    <Option type='single-option' value={'all'} label={this.$t('ALL')}*/}
        {/*            selected={this.trainingPlansFilters.type === undefined} select={this.filterByType}*/}
        {/*            detail={this.trainingPlans.length.toString()} />*/}
        {/*    <Option type='single-option' value={'home'} label={this.$t('PAGE.CONTENT.TRAINING_PLAN.HOME_PLANS')}*/}
        {/*            selected={this.trainingPlansFilters.type === 'home'} select={this.filterByType}*/}
        {/*            detail={this.trainingPlans.filter((w) => w.trainingPlanType === 'home').length.toString()} />*/}
        {/*    <Option type='single-option' value={'tracked'} label={this.$t('PAGE.CONTENT.TRAINING_PLAN.TRACKED')}*/}
        {/*            selected={this.trainingPlansFilters.type === 'tracked'} select={this.filterByType}*/}
        {/*            detail={this.trainingPlans.filter((w) => w.trainingPlanType === 'tracked').length.toString()} />*/}
        {/*  </OptionGroup>*/}
        {/*</Select>*/}

        {this.allowAllPlans && this.renderTypeSelect(h)}
      </Form>
      <div class='option-list'>
        <InfiniteScrollList
          fetchNextPageItems={this.fetchNextPage}
          itemsPerPage={25}
          mapItem={this.mapTrainingPlan}
          items={this.trainingPlans}
          filters={this.trainingPlansFilters}
          errorMessage={this.getErrorScreen(h)}
        />
      </div>
    </div>
  }

  getErrorScreen (h: CreateElement) {
    if (this.error) {
      return <ErrorScreen title={this.$t('PAGE.CONTENT.TRAINING_PLAN.REQUEST_ERROR')}
                          message={this.$t(this.error.messageKey)}>
        <Link align='center' click={() => {
          this.error = null
          return this.resetFilters()
        }} label={this.$t('TRY_AGAIN')} variant='colored' />
      </ErrorScreen>
    }
    if (!this.trainingPlans.length && this.filtersApplied()) {
      return <ErrorScreen
        message={this.trainingPlansFilters.name ? this.$t('PAGE.CONTENT.TRAINING_PLAN.NOT_FOUND.FILTER.NAME', { query: this.trainingPlansFilters.name }) : this.$t('PAGE.CONTENT.TRAINING_PLAN.NOT_FOUND.FILTER.GENERIC')}>
        {this.allowAllPlans ? <Link variant='colored' align='center' click={this.resetFilters}
              label={this.$t('PAGE.CONTENT.TRAINING_PLAN.RESET_FILTERS')} /> : null}
      </ErrorScreen>
    }
    return <ErrorScreen message={this.$t('PAGE.CONTENT.TRAINING_PLAN.NO_PLANS')} />
  }

  fetchNextPage (page, itemsPerPage) {
    const memberId = SessionManager.Instance.isManager() ? this.selectedMember!.id : this.member!.id

    return new TrainingPlanService().getTrainingPlans(page, itemsPerPage, this.trainingPlansFilters.type, this.trainingPlansFilters.name, memberId)
      .then(response => {
        response.trainingPlans.forEach((item => this.trainingPlans.push(item)))

        this.noOfClubTrainings = response.noOfClubTrainings
        this.noOfMemberTrainings = response.onOfMemberTrainings
        return Promise.resolve({ totalNoOfPages: response.totalPages })
      }).catch(error => {
        this.error = error
        return Promise.reject(error)
      })
  }
}
